import { Stack } from '@mui/material';
import { ClientActivity, ClientActivityProps } from './client-activity';

export type ClientActivityViewProps = Partial<ClientActivityProps>;

export const ClientActivityView = ({ clientId, partnerId }: ClientActivityViewProps) => {
  if (clientId === undefined || partnerId === undefined) {
    return null;
  }
  return (
    <Stack spacing={2} p={2}>
      <ClientActivity clientId={clientId} partnerId={partnerId} />
    </Stack>
  );
};
